import React from 'react';
import Wrapper from './styles';
import { useSportLobbyCategoriesLinks } from '../../../../hooks/main-navigation-v2';
import { useStore } from '../../../../hooks/useStore';
import { stores } from '../../../../stores';
import { getRoute, isActiveRoute } from '../../../../services/router';
import SportLobbyCategoriesV2MobileButton from './button/SportLobbyCategoriesV2MobileButton';

export default function SportLobbyCategoriesV2Mobile() {
    const [liveMatchesCount] = useStore(stores.sports.liveMatchesCount);
    const links = useSportLobbyCategoriesLinks();

    //we will add sport-menu in the future, that's why I commented it (not deleted)
    return (
        <Wrapper>
            {/* <SportLobbyCategoriesV2MobileButton
                icon="sport-menu"
                label={translate('Sport menu')}
                isSelected={isSportSideMenuOpen}
                onClick={() => setIsSportSideMenuOpen(!isSportSideMenuOpen)}
            />
            <div className="sport-menu-divider" /> */}
            {links.map(({ route, icon, label }) => {
                const isLiveCard = route.includes(`${getRoute('sport.live')}`);
                const isSelected = isActiveRoute(route, false);

                return (
                    <SportLobbyCategoriesV2MobileButton
                        key={route}
                        icon={icon}
                        label={label}
                        isSelected={isSelected}
                        url={route}
                        {...(isLiveCard && liveMatchesCount > 0 && { liveMatchesCount })}
                    />
                );
            })}
        </Wrapper>
    );
}
